import styled from "@emotion/styled";

export const ButtonsWrapper = styled.div`
  text-align: center;
  margin-top: 20px;
`;

export const Field = styled.div`
  margin-bottom: 15px;
  input {
    width: 100%;
    margin-top: 5px;
  }
`;

export const RenameForm = styled.form`
  transition: 0.5s;
`;
